export default __webpack_public_path__ + "static/media/Asset 15.088c3fc9.png";